/* istanbul ignore file */
import { Issue } from './Issue';
import TestStepsCollection from './TestStepsCollection';

export default class TestCase {
  /* It's string in many places which is a bug!
   * Should only be a number.
   * To avoid further bugs I added " | string " */
  id: number | string;
  name: string;
  expanded: boolean;
  testSteps: TestStepsCollection;
  issue: Issue | Promise<Issue>;
  constructor(
    id: number | string,
    name: string,
    testSteps: TestStepsCollection,
    issue: Issue | Promise<Issue>,
    expanded = false
  ) {
    this.id = id;
    this.name = name;
    this.testSteps = testSteps;
    this.expanded = expanded;
    this.issue = issue;
  }
}
